import { AuthProvider } from './auth/Authenticator';
import Rotas from './rotas';
import { PrimeReactProvider } from 'primereact/api';

global.uf = 'BA'

function App() {
  return (
    <PrimeReactProvider>
      <AuthProvider>
        <Rotas />
      </AuthProvider>
    </PrimeReactProvider>

  );
}

export default App;
